import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  ConnectionsListComponent
} from '@fry/connections/components/connections-list/connections-list.component';
import { AuthGuard } from '@fry/lib/guards';
import { SYSTEM_ROLE_ID } from "@fry/lib/roles/roles.system";

const routes: Routes = [
  {
    path: '', // Base route for connections page
    component: ConnectionsListComponent,
    canActivate: [
      AuthGuard // Optional: Protect the route
    ],
    data: {
      requiredRole: SYSTEM_ROLE_ID.ADMIN,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConnectionsRoutingModule { }
